import React from "react";
import { Card, Breadcrumb } from "react-bootstrap";
import styles from "./PatientHeader.module.scss";
import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface PatientHeaderProps {
  user: User;
  age: number | null;
  breadcrumbItems: BreadcrumbItem[];
}

const PatientHeader: React.FC<PatientHeaderProps> = ({ user, age, breadcrumbItems }) => {
  return (
    <Card className={styles.card}>
      <Card.Body>
        <h1>{user?.name}</h1>
        {age !== null && <p>{age} anos</p>}

        <Breadcrumb className={styles.breadcrumb}>
          {breadcrumbItems.map((item, index) => (
            item.href ? (
              <Breadcrumb.Item key={index} linkAs={Link} linkProps={{to: item.href}}>
                {item.label}
              </Breadcrumb.Item>
            ) : (
              <Breadcrumb.Item key={index} active>
                {item.label}
              </Breadcrumb.Item>
            )
          ))}
        </Breadcrumb>
      </Card.Body>
    </Card>
  );
};

export default PatientHeader;
